import $ from 'jquery';
import {scrollWithOffset} from '../base/utils';

class FilteredList {
    constructor(el) {
        this.$el = $(el);
        this.$select = this.$el.find('select');
        this.$label = this.$el.find('.js-filter-label');
        this.$trigger = this.$el.find('.js-filter-trigger');
        this.$links = this.$el.find('.js-filter-categories');
        this.$itemsContainer = this.$el.find('.js-filtered-list-items');
        this.$items = this.$itemsContainer.children();
        this.$showAll = this.$el.find('.js-filtered-list-show-all');
        this.$all = this.$links.find('[data-cat=""]');
        this.$empty = this.$el.find('.js-filtered-list-empty');

        this.noAnchor = this.$el.hasClass('no-anchor');

        this.events();
    }

    events() {
        this.$select.on('change', () => {
            let categoryName = this.$select.find('option:selected').data('name');

            this.set(this.$select.val(), categoryName);

            this.filter();
        });

        this.$links.on('click', 'a, .item', e => {
            let $el = $(e.currentTarget);

            e.preventDefault();

            this.set($el.data('cat'), $el.text(), $el);

            this.toggleFiltersList();

            this.filter();
        });

        this.$trigger.on('click', () => {
            this.toggleFiltersList();
        });

        this.$showAll.on('click', e => {
            e.preventDefault();

            this.set('', this.$all.text(), this.$all);
            this.filter();
        });

        if (this.$links.hasClass('js-filter-categories-counter')) this.renderCounter();
        this.initFilters();

        window.onpopstate = e => {
            if (e.state) {
                this.set(e.state.value || '', e.state.label, undefined, true);
            } else {
                let $default = this.$links.find('.default');

                if (!$default.length)
                    $default = this.$all;

                this.set($default.data('cat'), this.$links.find('.default').text(), $default, true);
            }

            this.filter();
        }

        $('body').on('font-size-change', () => {
            this.$select.blur();
        });
    }

    set(value, label, $el, isPop) {
        this.value = value;

        this.$select.val(value);
        this.$label.text(label);
        this.$trigger.text(label);

        this.$links.find('.active').removeClass('active');

        if (!$el || !$el.length) {
            $el = this.$links.find(`[data-cat="${value}"]`);
        }
        $el.addClass('active');

        if (!isPop) {
            history.pushState({value: value, label: label}, label, `${$el.attr('href')}`);
        }
    }

    initFilters() {
        let categoryName = this.$select.find('option:selected').data('name'),
            $link;

        this.value = this.$select.val();

        $link = this.$links.find(`[data-cat="${this.value}"]`);

        this.$label.text(categoryName);
        this.$trigger.text(categoryName);

        this.filter(this.noAnchor || !this.value || $link.hasClass('default'));
    }

    renderCounter() {
        let counters = {
            all: 0
        };

        this.$items.each((i, el) => {
            let $el = $(el),
                categories = $el.data('cat').trim().split(' ');

            counters.all++;
            categories.forEach(category => {
                if (counters[category]) counters[category]++;
                else counters[category] = 1;
            });
        })
        this.$links.find('a').each((i, el) => {
            let $el = $(el),
                category = $el.data('cat'),
                counter = counters[category] ? counters[category] : 0;

            if (category === '') counter = counters.all;

            if (counter === 0) {
                $el.closest('li').hide();
            } else {
                $el.append(` <span>(${counter})</span>`);
            }
        });
        this.$select.find('option').each((i, el) => {
            let $el = $(el),
                name = $el.text(),
                category = $el.attr('value'),
                counter = counters[category] ? counters[category] : 0;

            if (category === '') counter = counters.all;
            $el.append(` (${counter})`);
            $el.data('name', `${name} (${counter})`);
        });
    }

    getTopPosition() {
        return parseFloat(this.$itemsContainer.offset().top) - parseFloat(this.$itemsContainer.css('margin-top')) + 'px';
    }

    toggleFiltersList() {
        this.$links.toggleClass('open');
        this.$el.trigger('filter-toggle');
    }

    filter(noScroll) {
        this.$itemsContainer.addClass('fade-out');
        this.$itemsContainer.toggleClass('is-all', this.value === '');

        setTimeout(() => {
            let hasItems;

            if (this.value) {
                this.$items.addClass('filter-hidden')
                    .filter(`[data-cat~="${this.value}"]`).removeClass('filter-hidden');
            } else { // "wszystkie"
                this.$items.removeClass('filter-hidden');
            }

            hasItems = this.$items.filter(':not(".filter-hidden")').length > 0;

            this.$empty.toggleClass('hidden', hasItems);
            if (!hasItems) {
                this.$empty.find('.link').fancyHover('redraw');
            }

            if (!noScroll) {
                scrollWithOffset(this.$itemsContainer[0], null, document.getElementById('top-bar'));
            }
            $('.filter-label, .filter-list .item').fancyHover('redraw');
            this.$itemsContainer.removeClass('fade-out');
        }, 300);
    }
}

export default FilteredList;



// WEBPACK FOOTER //
// ./sources/js/components/filtered-list.js